import type { FC } from 'react';
import React from 'react';
import { useBrand } from '@edreamsodigeo/frontend-core';
import { Box } from '@edreamsodigeo/prisma-design-system';

import Tooltip from '~shared/MapCard/MapCardTooltip';
import { useBrandColor } from '~clientState/hooks';

const styleTransform = {
  transform: 'translate(-50%, -50%)',
};
const NormalDot: FC<{ x: number; y: number }> = ({ x, y }) => {
  const brand = useBrand();
  const { backgroundColor } = useBrandColor({ brand });
  return (
    <Box
      data-testid={`normal-dot-${x}-${y}`}
      data-chromatic="ignore"
      sx={styleTransform}
      position="absolute"
      borderRadius="50%"
      border="1px solid"
      borderColor="neutral.0"
      width="10px"
      height="10px"
      left={`calc(100% * ${x})`}
      top={`calc(100% * ${y})`}
      backgroundColor={backgroundColor}
    />
  );
};

const DiscountDot: FC<{ x: number; y: number; discount: number }> = ({
  x,
  y,
  discount,
}) => (
  <Box
    data-testid={`discount-dot-${x}-${y}`}
    data-chromatic="ignore"
    sx={styleTransform}
    backgroundColor="deals.30"
    position="absolute"
    borderRadius="50%"
    border="1px solid"
    borderColor="neutral.0"
    width="10px"
    height="10px"
    left={`calc(100% * ${x})`}
    top={`calc(100% * ${y})`}
  >
    <Tooltip>{`-${discount}%`}</Tooltip>
  </Box>
);

export { NormalDot, DiscountDot };
